import useJsaReportsEnabled from 'containers/jsa-reports/hooks/useJsaReportsEnabled/useJsaReportsEnabled';
import { useActiveMember } from 'hooks/store';

export default function useSafetyJsaReportsViewable() {
  const activeMember = useActiveMember();
  const isJsaReportsEnabled = useJsaReportsEnabled();

  return isJsaReportsEnabled && activeMember.position?.createSafetyAnalysisReports === true;
}
